import { render, staticRenderFns } from "./ConfigContactDialog.vue?vue&type=template&id=61ab8ad6&scoped=true"
import script from "./ConfigContactDialog.vue?vue&type=script&lang=js"
export * from "./ConfigContactDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfigContactDialog.vue?vue&type=style&index=0&id=61ab8ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ab8ad6",
  null
  
)

export default component.exports